export default __webpack_public_path__ + "static/media/loading2.9129c0f1.svg";